module.exports = __webpack_public_path__ + "media/images/design/sizeS-ccae6f18ba35f54b12dc1b6e403d9ee2.png";